import { offlineIngestMessage } from "../../../state/actions/chats";
import store from "../../../state/configureStore";

// Helper function to parse message and options safely
const parseJson = (data, fallback) => {
    try {
        return typeof data === "string" && data !== null ? JSON.parse(data) : data;
    } catch {
        return fallback;
    }
};

const tell = (message, botContext) => {
    const { userDetails, botId, capabilities, getConversationContext } = botContext;
    const { userId } = userDetails;
    const { conversationId: contextConversationId } = getConversationContext();
    const messageType = message.getMessageType();
    const messageId = message.getMessageId();
    const createdDate = message.getMessageDate();
    const createdBy = message.getCreatedBy();
    const messageContent = message.getMessage();
    const messageOptions = message.getMessageOptions();
    const messageUuid = message._uuid;

    const conversationId =
        window.lastMsg && window.lastMsg.messageId === messageId
            ? window.lastMsg.conversationId
            : contextConversationId;

    const messageObj = {
        userId,
        conversation: conversationId,
        bot: botId,
        createdOn: createdDate,
        createdBy,
        contentType: capabilities.MessageTypeConstantsToInt[messageType],
        messageType,
        addedByBot: true,
        messageId,
        uuid: messageUuid,
        messageDate: createdDate,
        botKey: null,
        status: 0,
        message: parseJson(messageContent, messageContent),
        options: parseJson(messageOptions, messageOptions),
    };

    //store and handle message locally with tabStack (within redux)
    store.dispatch(offlineIngestMessage(messageObj, messageObj.conversation || conversationId));
};

export default tell;
